import { Api, HttpClient, UsedCardsStatsApi } from '../../../api'
import { AddUsedCardsStat, GroupedUsedCardsStat, UsedCardsStatOptions, UsedCardsStatsService } from './usedCardsStats'
import { Context, PaginatedResult, enumMapToSame, mapDtoToEntity } from '../../../common'
import { SalesPointType } from '../../salesPoints'

function mapDtoToGroupedUsedCardsStat(dto: Api.GroupedUsedCardsStat): GroupedUsedCardsStat {
  return {
    municipalEntity: mapDtoToEntity({ ...dto.municipalEntity }),
    salesPoint: mapDtoToEntity({
      ...dto.salesPoint,
      type: dto.salesPoint.type ? enumMapToSame<Api.SalesPoint.Type, SalesPointType>(dto.salesPoint.type) : undefined,
    }),
    values: dto.values,
  }
}

export class RemoteUsedCardsStatsService implements UsedCardsStatsService {
  private api: UsedCardsStatsApi

  constructor(httpClient: HttpClient) {
    this.api = new UsedCardsStatsApi(httpClient, undefined, '')
  }

  async formReport(
    ctx: Context,
    opts?: UsedCardsStatOptions | undefined,
  ): Promise<{ groupedBySP: PaginatedResult<GroupedUsedCardsStat>; groupedByME: GroupedUsedCardsStat[] }> {
    const result = await this.api.usedCardsStatsFormReport(ctx, {
      ids: opts?.filter?.ids,
      salesPointId: opts?.filter?.salesPointId,
      municipalEntityId: opts?.filter?.municipalEntityId,
      dateFrom: opts?.filter?.dateFrom?.toString(),
      dateTo: opts?.filter?.dateTo?.toString(),
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
      orderBy: opts?.order?.field,
      direction: opts?.order?.direction,
    })

    return {
      groupedBySP: {
        ...result.body.object.groupedBySP,
        items: result.body.object.groupedBySP.items.map(mapDtoToGroupedUsedCardsStat),
      },
      groupedByME: result.body.object.groupedByME.map(mapDtoToGroupedUsedCardsStat),
    }
  }

  async add(ctx: Context, usedCardsStat: AddUsedCardsStat): Promise<string> {
    const result = await this.api.usedCardsStatsAdd(ctx, {
      ...usedCardsStat,
      dataEntryDate: usedCardsStat.dataEntryDate.toString(),
    })

    return result.body.id
  }
}
